// packages
import cx from 'classnames';

/**
 * @param {object} props
 * @param {string} props.className
 * @param {boolean} props.disabled
 * @param {Record<string, string>} props.errors
 * @param {string} props.label
 * @param {string} props.name
 * @param {React.ChangeEvent} props.onChange
 * @param {{name: string, value: string}[]} props.options
 * @param {string} props.value
 * @returns {JSX.Element}
 */
export default function SelectFormField({
  className,
  disabled = false,
  errors = {},
  label = name,
  name,
  onChange,
  options,
  value,
}) {
  const id = `${name}-field`;
  const error = errors[name];

  if (error) {
    label += ` ${error}`;
  }

  return (
    <div className={cx('minimal-field', className, { error: error })}>
      <div className="minimal-field-input-container">
        <select
          id={id}
          className="minimal-text-input modified-text-input minimal-select-input"
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
        >
          <option value="">-</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
        <span className="custom-select-symbol"></span>
      </div>
      <label htmlFor={id} className="minimal-label">
        {label}
      </label>
    </div>
  );
}
